<template>
  <div id="member">
    <el-dialog
      :modal="false"
      :visible.sync="dialogVisible"
      :before-close="close"
    >
      <div class="memberbox">
        <div class="box-left">
          <div class="box-left-title">
            <img
              src="@/assets/mobile/left-vip-bg-6daa9c4b.png"
              alt=""
              class="bg"
            />
            <div class="title">
              <div class="icon"></div>
              <p class="titlep1">{{ memberconfig.title }}</p>
              <p class="titlep2">{{ memberconfig.content }}</p>
            </div>
          </div>
          <el-scrollbar>
            <div class="title-tip-content flex-1">
              <div
                class="title-tip-box"
                v-for="(item, index) in memberconfig.list"
                :key="index"
              >
                <div class="title-name">{{ item.title }}</div>
                <div class="title-tip" v-for="(list, i) in item.list" :key="i">
                  <span class="icon icon-member-tip"></span
                  ><span>{{ list.content }}</span>
                </div>
              </div>
            </div>
          </el-scrollbar>
        </div>
        <div class="box-right">
          <div class="box-right-title">
            <img :src="userdata.avatar" alt="" />
            <p>{{ userdata.nickname }}</p>
            <span> </span> 
            <!-- <span>您还不是会员，开通标准会员畅享众多AI创作功能 </span> -->
          </div>
          <div class="box-right-pg">
            <div class="member-card-box" :style="cardStyle">
              <div
                @click="changeorder(index)"
                :class="[
                  'member-card',
                  memberindex == index ? 'selected-item' : '',
                ]"
                v-for="(item, index) in member"
                :key="index"
              >
                <div class="name">{{ item.title }}</div>
				<div class="name">{{ item.content }}</div>
                <div class="card-money-box">
                  <span>￥</span>
                  <span class="big">{{ Number(item.current_price) }}</span>
                  <span>{{item.unit}}</span>
                </div>
                <div class="card-discount">
                  ￥{{ Number(item.original_price) }}
                </div>
                <div class="card-tip-top" v-show="memberindex == index">
                  <span class="card-tip-title">{{ item.discount_prompt }}</span>
                </div>
              </div>
            </div>
            <div class="function-list">
              <div class="function-list-item">
                <div class="icon icon-free-text"></div>
                <div class="function-text">无限文字创作</div>
              </div>
              <div class="function-list-item">
                <div class="icon icon-generated-video"></div>
                <div class="function-text">AI生成视频</div>
              </div>
              <div class="function-list-item">
                <div class="icon icon-photo-person"></div>
                <div class="function-text">照片数字人</div>
              </div>
              <div class="function-list-item">
                <div class="icon icon-face-video"></div>
                <div class="function-text">AI换脸秀</div>
              </div>
              <div class="function-list-item">
                <div class="icon icon-ai-photo"></div>
                <div class="function-text">AI写真</div>
              </div>
            </div>
            <div class="limit-time-offer">
              <div class="limit-left">
                <span>已选择</span
                ><span class="limit-type">购买{{ memberdata.title }}</span>
              </div>
              <div class="limit-right">
                <div class="icon icon-limit-time"></div>
                <span
                  >优惠券已减￥{{
                    Number(order.coupon_money)
                  }}</span
                >
              </div>
            </div>
			<div style="text-align: center;" class="pay-box" v-if="order.pay_money <= 0">
				<p style="margin-top: 20px;">已使用:{{order.coupon_title}}</p>
				<el-button @click="exchange" style="text-align: center;margin-top: 20px;" type="danger" >立即兑换</el-button>
			</div>
            <div class="pay-box" v-if="order.pay_money > 0">
              <div class="pay-title">支付方式: 扫码支付</div>
              <div class="pay-content-box">
                <div class="pay-code">
                  <img :src="code_url" />
                </div>
                <div class="pay-right">
                  <div class="money-box">
                    支付：
                    <span class="pay-money">
                      ￥
                      <span class="money"
                        ><div class="countup-wrap">
                          <span>{{ Number(order.pay_money) }}</span>
                        </div></span
                      ></span
                    ><span class="pay-discount">
                      已优惠￥{{
                        Number(
                          order.coupon_money
                        )
                      }}</span
                    >
                  </div>
                 <!-- <div class="alipay-box">
                    <span class="icon icon-alipay"></span
                    ><span>支付宝扫码支付</span>
                  </div> -->
                  <div class="weichat-box">
                    <span class="icon icon-weichat"></span
                    ><span>微信扫码支付</span>
                  </div>
                  <div class="pay-tip">
                    支付即视为您同意并接受<span class="rule" @click="jumppage(2)">《隐私政策》</span
                    >和<span class="rule" @click="jumppage(1)">《服务协议》</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
var _this
import {
  configRecharge,
  configVip,
  userInfo,
  orderCreate,
  payPay,
  orderQuery,
  exchange,
} from "@/api/user";
export default {
  data() {
    return {
      userdata: this.$store.userInfo,
      dialogVisible: true,
      memberindex: 0,
      memberdata: {},
      memberconfig: [],
      memberConfigList: [],
      member: [],
	  cardStyle:'justify-content: space-around;',
      time: "",
      code_url: "",
	  order:{
		  coupon_money:0,
		  pay_money:0,
	  },
    };
  },
  mounted() {
    _this = this
	console.log()
    // userInfo().then((res) => {
    //   this.userdata = res.data;
    // });
    configRecharge().then((res) => {
    });
    configVip().then((res) => {
      this.member = res.data.list;
      this.memberdata = this.member[0];
      // this.memberconfig = res.data.config[0];
	  if(this.member.length == 2) {
	  		this.memberconfig = res.data.config[0];
	  }else {
	  		this.memberconfig = res.data.config[0];
	  }
      this.memberConfigList = res.data.config;
      this.orderCreate();
    });
  },
  methods: {
	exchange() {
		const loading1 = this.$loading({
			lock: true,
			text: '加载中....',
			spinner: 'el-icon-loading',
			background: 'rgba(0, 0, 0, 0.7)'
		});
	    exchange({id:this.order.id}).then(res => {
		  if(res.code == 0) {
			  _this.$message({
				message: res.message,
				type: "success",
			  });
			  _this.dialogVisible = false;
			  if(this.$route.path == '/order') {
				  setTimeout(function() {
				  				  location.reload();
				  }, 2000)
			  }else {
				   this.$router.push({ path: "/order"});
			  }
		  }else {
			  _this.$message({
				message: res.message,
				type: "error",
			  });
		  }
		  loading1.close();
	   });
	},
    jumppage(index) {
      switch (index) {
        case 1:
          window.open(this.$store.website.serve_url)
          break;
        case 2:
          window.open(this.$store.website.privacy_url)
          break;
      }
    },
    close() {
      clearInterval(this.time);
      this.$emit("closemember");
    },
    changeorder(index) {
      this.memberindex = index;
	  if(this.member.length == 2) {
		  this.memberconfig = this.memberConfigList[index];
	  }else {
		  this.memberconfig = this.memberConfigList[index];
	  }
	  this.memberdata = this.member[index];
	  
      this.orderCreate();
    },
    orderCreate() {
      let create = {
        type: "vip",
        id: this.memberdata.id,
      };
      orderCreate(create).then((res) => {
		this.order = res.data;
		if(res.data.pay_money > 0) {
			this.payPay(res.data.id);
		}
		clearInterval(this.time);
      });
    },
    payPay(id) {
      let pay = {
        id: id,
        pay_type: "scan",
      };
      payPay(pay).then((res) => {
        this.code_url = res.data.code_url;
        this.time = setInterval(function(){
          orderQuery({ id: id }).then((res) => {
            if (res.data.order.status == 1) {
              _this.$message({
                message: "支付成功",
                type: "success",
              });
              location.reload();
            }
          });
        }, 2000);
      });
    },
  },
};
</script>

<style lang="less">
#member {
  .el-dialog {
    height: 540px !important;
    width: 790px !important;
    border-radius: 8px !important;
    overflow: hidden;
    .el-dialog__body {
      padding: 0 !important;
      height: 100%;
    }
    .el-dialog__header {
      position: absolute;
      width: 100%;
      z-index: 99;
      .el-dialog__headerbtn {
        top: 4px;
        color: #000;
        font-size: 30px;
      }
    }
    .memberbox {
      display: flex;
      height: 100%;
      .box-left {
        width: 250px;
        height: 100%;
        padding: 22px;
        flex-direction: column;
        background: linear-gradient(180deg, #404040 0%, #090606 100%);
        position: relative;
        .box-left-title {
          position: relative;
          .bg {
            top: 0;
            left: 0;
            position: absolute;
            width: 100%;
          }
          .title {
            text-align: center;
            .icon {
              width: 23px;
              height: 19px;
              margin-top: 1px;
              background: url(../../assets/ai-pc-icon-6fdc37eb.png) no-repeat;
              display: inline-block;
              background-position: -42px -261px;
            }
            .titlep1 {
              font-weight: 700;
              font-size: 20px;
              margin: 4px 0;
              background: linear-gradient(90deg, #fcf1e6 4.23%, #f9dec4 100%);
              -webkit-text-fill-color: transparent;
              -webkit-background-clip: text;
              background-clip: text;
            }
            .titlep2 {
              font-size: 11px;
              margin-bottom: 16px;
              color: #c59e7b;
            }
          }
        }
      }
      .box-right {
        flex: 1 0 10%;
        .box-right-title {
          padding: 12px 0 12px 17px;
          display: flex;
          width: 100%;
          height: 48px;
          background: #f5f7f9;
          align-items: center;
          justify-content: space-between;
          border-top-right-radius: 12px;
          position: relative;
          img {
            width: 32px;
            border-radius: 50px;
            overflow: hidden;
          }
          span {
            flex: 1 0 10%;
          }
          p {
            max-width: 98px;
            font-weight: 400;
            font-size: 14px;
            line-height: 18px;
            color: #1d2129;
            margin-left: 8px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          span {
            font-weight: 400;
            font-size: 12px;
            line-height: 16px;
            color: #999;
            margin-left: 8px;
          }
        }
        .box-right-pg {
          padding: 24px;
          .member-card-box {
            display: flex;
            justify-content: space-between;
            .member-card {
              flex: 0 0 30%;
              height: 147px;
              background: #ffffff;
              border: 1px solid #fafafa;
              box-shadow: 0 2px 8px rgba(237, 191, 121, 0.1),
                0 3px 8px rgba(46, 27, 10, 0.04);
              border-radius: 8px;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              position: relative;
              cursor: pointer;
              text-align: center;
              .name {
                font-size: 14px;
                color: #333;
              }
              .card-money-box {
                font-size: 12px;
                color: #333;
                .big {
                  font-size: 36px;
                  font-weight: 700;
                }
              }
              .card-discount {
                font-size: 12px;
                text-decoration-line: line-through;
                color: #613f1a;
              }
              .card-tip-top {
                width: 65px;
                height: 24px;
                background: url(../../assets/ai-pc-icon-6fdc37eb.png) no-repeat;
                display: flex;
                justify-content: center;
                align-items: center;
                background-position: -155px -216px;
                position: absolute;
                top: -8px;
                right: -1px;
                .card-tip-title {
                  color: #fff;
                }
              }
            }
            .selected-item {
              background: linear-gradient(
                  180deg,
                  rgba(255, 242, 227, 0.3) 4.01%,
                  rgba(255, 227, 204, 0.3) 100%
                ),
                #ffffff;
              border: 2px solid #f67e29;
              box-shadow: 0 3px 8px rgba(46, 27, 10, 0.04);
            }
          }
          .function-list {
            display: flex;
            justify-content: space-between;
            text-align: center;
            width: 492px;
            height: 62px;
            padding: 5px 26px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            background: #ffffff;
            margin: 20px auto;
            gap: 20px;
            .icon {
              display: inline-block;
              background: url(../../assets/ai-pc-icon-6fdc37eb.png) no-repeat;
              width: 32px;
              height: 32px;
            }
            .icon-free-text {
              background-position: -228px -213px;
            }
            .icon-generated-video {
              background-position: -308px -212px;
            }
            .icon-photo-person {
              background-position: -269px -212px;
            }
            .icon-face-video {
              background-position: -388px -169px;
            }
            .icon-ai-photo {
              background-position: -379px -105px;
            }
          }
          .limit-time-offer {
            width: 492px;
            height: 42px;
            margin-top: 16px;
            display: flex;
            align-items: center;
            justify-content: space-between;
            background: #fff4ea;
            border-radius: 8px 8px 0 0;
            padding: 8px 12px 16px;
            font-size: 12px;
            line-height: 16px;
            color: #ed8e58;
            .limit-type {
              font-weight: 700;
              font-size: 12px;
              line-height: 16px;
              color: #1d2129;
              margin-left: 4px;
            }
          }
          .pay-box {
            width: 492px;
            background: #ffffff;
            border-radius: 8px;
            padding: 16px 0 16px 12px;
            margin-top: -6px;
            .pay-right {
              margin-left: 12px;
            }
            .icon {
              background: url(../../assets/ai-pc-icon-6fdc37eb.png) no-repeat;
              display: inline-block;
            }
            .alipay-box {
              margin: 12px 0 8px;
              display: flex;
              align-items: center;
            }
            .weichat-box {
              display: flex;
              align-items: center;
            }
            .alipay-box .icon-alipay {
              width: 16px;
              height: 16px;
              background-position: -283px -21px;
              margin-right: 4px;
            }
            .weichat-box .icon-weichat {
              width: 16px;
              height: 16px;
              background-position: -307px -21px;
              margin-right: 4px;
            }
            .pay-title {
              font-weight: 400;
              font-size: 12px;
              line-height: 16px;
              color: #999;
              margin-bottom: 12px;
            }
            .pay-content-box {
              display: flex;
              align-items: center;
            }
            .pay-code {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 110x;
              height: 110px;
              border: 1px solid #ececec;
              white-space: nowrap;
              img {
                width: 108px;
              }
            }
            .pay-tip {
              font-weight: 400;
              font-size: 12px;
              line-height: 18px;
              display: flex;
              align-items: center;
              color: #999;
              white-space: nowrap;
              margin-top: 4px;
              transform: scale(0.84);
              margin-left: -20px;
              .rule {
                color: #4091f7;
                cursor: pointer;
              }
            }
            .money-box {
              font-weight: 400;
              font-size: 12px;
              line-height: 16px;
              color: #4e5969;
              display: flex;
              align-items: center;
              .pay-money {
                color: #ff5556;
                .money {
                  font-weight: 700;
                  font-size: 32px;
                  margin-right: 4px;
                  display: inline-block;
                }
              }
              .pay-discount {
                font-weight: 400;
                font-size: 12px;
                line-height: 16px;
                color: #ff5556;
                margin-right: 4px;
              }
            }
          }
        }
      }
      .el-scrollbar {
        height: 400px;
        .el-scrollbar__wrap {
          overflow-x: hidden;
          .title-name {
            font-weight: 700;
            font-size: 13px;
            color: #fff3e9;
            margin-bottom: 8px;
          }
          .title-tip {
            display: flex;
            font-size: 12px;
            margin-bottom: 8px;
            color: #f8ddc5;
          }
          .icon-member-tip {
            width: 14px;
            height: 14px;
            margin-right: 8px;
            background: url(../../assets/ai-pc-icon-6fdc37eb.png) no-repeat;
            background-position: -351px -21px;
            display: inline-block;
          }
        }
      }
    }
  }
}
</style>